export const getDescopeAuthErrorMessage = (_error: any): string => {
  // TODO implement a more specific descope error handling
  return 'An unexpected error occurred. Please try again.';
};
